import './_empty-cart-recommendations.scss';
import component from './empty-cart-recommendations';

export default component;
